/*
 * @Author: your name
 * @Date: 2020-06-29 14:12:48

 * @LastEditTime: 2022-01-18 16:22:23

 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\router\maintain\index.js
 */
const maintain = [{
    path: '/maintainlist',
    name: 'maintainList',
    component: () =>
            import ('@/views/maintain/maintainlist.vue')
},
{
    path: '/deviceList',
    name: 'deviceList',
    component: () =>
            import ('@/views/device/deviceList.vue')
},
{
    path: '/deviceSave',
    name: 'deviceSave',
    component: () =>
            import ('@/views/device/deviceSave.vue')
},
{
    path: '/entranceVehicle',
    name: 'entranceVehicle',
    component: () =>
            import ('@/views/maintain/entrancevehicle.vue')
},
{
    path: '/entranceExit',
    name: 'entranceExit',
    component: () =>
            import ('@/views/maintain/entranceexit.vue')
},
{
    path: '/departure',
    name: 'departure',
    component: () =>
            import ('@/views/maintain/departure.vue')
},
{
    path: '/addentranceVehicle',
    name: 'AddentranceVehicle',
    component: () =>
            import ('@/views/maintain/addentrancevehicle.vue'),
    meta: {
        keepAlive: true
    }
},
{
    path: '/tomaintainlist',
    name: 'toMaintainList',
    component: () =>
            import ('@/views/tomaintain/tomaintainlist.vue')
},
{
    path: '/QualityCheckList',
    name: 'QualityCheckList',
    component: () =>
            import ('@/views/qualitycheck/list.vue')
},
{
    path: '/workorderlist',
    name: 'workorderlist',
    component: () =>
            import ('@/views/maintain/workorderlist.vue')
},
{
    path: '/workorderlistsearch',
    name: 'workorderlistsearch',
    component: () =>
            import ('@/views/maintain/workorderlistsearch.vue')
},
{
    path: '/workorderlistsearchdetail',
    name: 'workorderlistsearchdetail',
    component: () =>
            import ('@/views/maintain/workorderlistsearchdetail.vue'),
    meta: { keepAlive: true }
},
{
    path: '/partsrepair',
    name: 'Partsrepair',
    component: () =>
            import ('@/views/maintain/partsrepair.vue')
},
{
    path: '/partsrepairs',
    name: 'Partsrepairs',
    component: () =>
            import ('@/views/maintain/partsrepairs.vue')
},
{
    path: '/partsrepairse',
    name: 'Partsrepairse',
    component: () =>
            import ('@/views/maintain/partsrepairse.vue')
},
{
    path: '/partsrepairsjiesuan',
    name: 'Partsrepairs',
    component: () =>
        import ('@/views/maintain/partsrepairsjiesuan.vue')
},
{
    path: '/partsrepairszhijian',
    name: 'Partsrepairs',
    component: () =>
        import ('@/views/maintain/partsrepairszhijian.vue')
},
{
    path: '/StatementList',
    name: 'StatementList',
    component: () =>
            import ('@/views/maintain/StatementList.vue')
}, {
    path: '/qualityCheckList',
    name: 'QualityCheckList',
    component: () =>
            import ('@/views/qualitycheck/list.vue')
},
{
    path: '/StatementListDetail',
    name: 'StatementListDetail',
    component: () =>
           import ('@/views/maintain/StatementListDetail.vue')
},
{
    path: '/VehicleInfo',
    name: 'VehicleInfo',
    component: () =>
           import ('@/views/maintain/VehicleInfo.vue')
},
{
    path: '/StatementDetailFac',
    name: 'StatementDetailFac',
    component: () =>
           import ('@/views/maintain/StatementDetailFac.vue')
},
{
    path: '/StatementDetailFac',
    name: 'StatementDetailFac',
    component: () =>
           import ('@/views/maintain/StatementDetailFac.vue')
},
{
    path: '/maintainInfo',
    name: 'maintainInfo',
    component: () =>
           import ('@/views/maintain/maintainInfo.vue')
},
{
    path: '/repairdispatch',
    name: 'repairdispatch',
    component: () => import('@/views/maintain/repairdispatch.vue') },
{
    path: '/dispatchList',
    name: 'DispatchList',
    component: () => import('@/views/maintain/dispatchList'),
    meta: {
        keepAlive: true
    }
},
{
    path: '/addentrancevehicledetail',
    name: 'Addentrancevehicledetail',
    component: () => import('@/views/maintain/addentrancevehicledetail')
},
{
    path: '/Sign',
    name: 'Sign',
    component: () => import('@/views/maintain/Sign')
},
{
    path: '/dispatching',
    name: 'Dispatching',
    component: () => import('@/views/maintain/dispatching')
},
{
    path: '/dispatchdetails',
    name: 'Dispatching',
    component: () => import('@/views/maintain/dispatching')
},
{
    path: '/fxdispatchdetails',
    name: 'Dispatching',
    component: () => import('@/views/maintain/dispatchList')
}, {
    path: '/faultrepaired',
    name: 'faultrepaired',
    component: () => import('@/views/maintain/faultrepaired.vue')
},
{
    path: '/QualityCheckDetail',
    name: 'QualityCheckDetail',
    component: () => import('@/views/qualitycheck/detail.vue')
}, {
    path: '/faultrepairedDetails',
    name: 'faultrepairedDetails',
    component: () => import('@/views/maintain/faultrepaireddetails.vue')
}
]

export default maintain
